/* Leaf Rain Animation Handler */

class LeafRain {
  constructor() {
    this.container = null;
    this.leafCount = 25; // Number of leaves to create
    this.duration = 5000; // 5 seconds for slower fall
    this.leafColors = [
      { fill: '#03604E' },
      { fill: '#68A095' },
      { fill: '#42887A' },
      { fill: '#106857' },
      { fill: '#024D3E' }
    ];
  }

  init() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.className = 'leaf-rain-container';
      document.body.appendChild(this.container);
    }
  }

  getRandomLeafSVG() {
    const color = this.leafColors[Math.floor(Math.random() * this.leafColors.length)];
    return `
      <svg aria-hidden="true" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <path fill="${color.fill}" d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
      </svg>
    `;
  }

  createLeaf() {
    const leaf = document.createElement('div');
    const sizes = ['small', 'medium', 'large'];
    const size = sizes[Math.floor(Math.random() * sizes.length)];

    leaf.className = `leaf ${size}`;
    leaf.innerHTML = this.getRandomLeafSVG();

    // Random horizontal starting position
    const startX = Math.random() * 100;
    leaf.style.left = `${startX}%`;

    // Random animation duration (4-7 seconds for slower fall)
    const fallDuration = 4 + Math.random() * 3;
    leaf.style.animationDuration = `${fallDuration}s`;

    // Random delay for staggered effect
    const delay = Math.random() * 4;
    leaf.style.animationDelay = `${delay}s`;

    // Randomly choose animation pattern
    const animations = ['fall', 'fall-sway-left', 'fall-sway-right'];
    const selectedAnimation = animations[Math.floor(Math.random() * animations.length)];
    leaf.style.animationName = selectedAnimation;
    leaf.style.animationFillMode = 'forwards';

    return leaf;
  }

  start() {
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      console.log('Leaf rain: Reduced motion detected, skipping animation');
      return;
    }

    this.init();
    console.log('Leaf rain: Container created', this.container);

    // Create and add leaves
    const leaves = [];
    for (let i = 0; i < this.leafCount; i++) {
      const leaf = this.createLeaf();
      leaves.push(leaf);
      this.container.appendChild(leaf);
    }

    console.log(`Leaf rain: Created ${leaves.length} leaves`, leaves);

    // Remove container after animation completes (longest possible duration is 7s + 1s delay)
    setTimeout(() => {
      leaves.forEach(leaf => leaf.remove());
      console.log('Leaf rain: Animation complete, leaves removed');
    }, 16000); // 8 seconds to ensure all leaves complete their animation
  }

  // Public method to trigger the animation
  static trigger() {
    const leafRain = new LeafRain();
    leafRain.start();
  }
}

// Make it globally available
window.LeafRain = LeafRain;

// Wait for DOM to be ready and subscribe to cart update events
document.addEventListener('DOMContentLoaded', function() {
  // Listen for add-to-cart events using the global PUB_SUB_EVENTS
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Only trigger if the source is 'product-form' (adding from product page)
      // This excludes cart updates from cart page, quick-add, removals, etc.
      if (event && event.source === 'product-form') {
        console.log('Product added from product page, triggering leaf rain');
        LeafRain.trigger();
      } else {
        console.log('Cart update from other source, skipping leaf rain', event);
      }
    });
  }
});
